// extracted by mini-css-extract-plugin
module.exports = {"label":"bm_cr","text":"bm_cn"};